import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';

const TOKEN_KEY = 'cafe_super_token';
const USER_KEY  = 'cafe_super_user';

const SuperAdminConfirmEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('Token missing hai URL mein.');
      return;
    }

    const confirm = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL || 'http://localhost:5000/api'}/super/change-email/confirm?token=${token}`
        );
        const data = await res.json();

        if (!res.ok) {
          setStatus('error');
          setMessage(data.message || 'Token invalid ya expire ho gaya.');
          return;
        }

        const { token: newJwt, email: newEmail } = data.data;

        // ✅ localStorage update karo
        localStorage.setItem(TOKEN_KEY, newJwt);

        const stored = localStorage.getItem(USER_KEY);
        if (stored) {
          try {
            const user = JSON.parse(stored);
            user.email = newEmail;
            localStorage.setItem(USER_KEY, JSON.stringify(user));
          } catch {}
        }

        setStatus('success');
        setMessage(newEmail);
        toast.success('Email successfully change ho gaya!');

        // ✅ 2 second baad automatically dashboard pe redirect karo
        setTimeout(() => {
          window.location.href = '/super-admin';
        }, 2500);

      } catch (err) {
        setStatus('error');
        setMessage('Server se connect nahi ho paya. Baad mein try karein.');
      }
    };

    confirm();
  }, [searchParams]);

  const goToDashboard = () => {
    window.location.href = '/super-admin';
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #1c1512 0%, #2d1f18 100%)',
    }}>
      <div style={{
        width: '100%', maxWidth: 420, margin: '0 16px',
        background: '#ffffff', borderRadius: 20,
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)', overflow: 'hidden',
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #7c3aed, #5b21b6)',
          padding: '36px 40px 28px', textAlign: 'center',
        }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>
            {status === 'loading' ? '⏳' : status === 'success' ? '✅' : '❌'}
          </div>
          <h1 style={{ color: '#fff', fontSize: 22, fontWeight: 700, margin: 0 }}>Email Confirmation</h1>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14, marginTop: 6 }}>Super Admin — Email Change</p>
        </div>

        <div style={{ padding: '32px 40px 40px', textAlign: 'center' }}>
          {status === 'loading' && (
            <>
              <div style={{ width: 48, height: 48, border: '4px solid #ede9fe', borderTopColor: '#7c3aed', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 20px' }} />
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
              <p style={{ color: '#6b7280', fontSize: 15 }}>Token verify ho raha hai...</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div style={{ width: 64, height: 64, background: '#f0fdf4', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: 28 }}>✅</div>
              <h2 style={{ color: '#166534', fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Email Change Ho Gaya!</h2>
              <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 6 }}>Aapka naya email:</p>
              <p style={{ color: '#7c3aed', fontSize: 16, fontWeight: 600, background: '#f5f3ff', padding: '8px 16px', borderRadius: 8, display: 'inline-block', marginBottom: 16 }}>{message}</p>
              <p style={{ color: '#9ca3af', fontSize: 13, marginBottom: 20 }}>Dashboard pe redirect ho raha hai...</p>
              <button onClick={goToDashboard} style={{ width: '100%', padding: '13px', background: 'linear-gradient(135deg, #7c3aed, #5b21b6)', color: '#fff', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
                Dashboard Pe Jao →
              </button>
            </>
          )}

          {status === 'error' && (
            <>
              <div style={{ width: 64, height: 64, background: '#fef2f2', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: 28 }}>❌</div>
              <h2 style={{ color: '#991b1b', fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Confirmation Failed</h2>
              <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 24, background: '#fef2f2', padding: '12px 16px', borderRadius: 8, border: '1px solid #fecaca' }}>{message}</p>
              <button onClick={goToDashboard} style={{ width: '100%', padding: '13px', background: '#f3f4f6', color: '#374151', border: 'none', borderRadius: 10, fontSize: 15, fontWeight: 600, cursor: 'pointer' }}>
                Dashboard Pe Wapas Jao
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuperAdminConfirmEmail;
